import React from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from '@weezevent/nacre';
import TicketCard, { TicketCardContent } from '../../../detail/components/ticket-card/ticketCard';
import { PreviewEmpty } from '../../../../sessions/components/previewEmpty';
import OrderSummary from './Order';
import SessionRate from './SessionRate';

export default function Summary({ form }) {
    const { t } = useTranslation();
    const { use_sessions } = form;

    const session = form.sessions[0]?.text;
    const rate = form.selected_rates[0]?.rate?.name;
    const selection = use_sessions ? form.sessions.length > 0 && form.selected_rates.length > 0 : form.selected_rates.length > 0;

    if (!selection) {
        return <PreviewEmpty title={t('attendees.addAttendees.previewEmptyTitle')} icon={<Icon name="cart" size="huge" />} />;
    }

    return (
        <TicketCard>
            <OrderSummary form={form} />
            {use_sessions ? <SessionRate session={session} rate={rate} /> : <TicketCardContent>{rate}</TicketCardContent>}
        </TicketCard>
    );
}
